import { useEffect, useState } from "react";
import { NewsService } from "../services/grapql";
import { countNewsHome } from "../services/variables";

export function usePostsCard() {
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function fetchPosts() {
      setLoading(true);
      setError(false);

      try {
        const response = await NewsService.getPostsCard({
          first: countNewsHome,
        });
        if (isMounted) {
          setData(response);
        }
      } catch (error) {
        if (isMounted) {
          setError(true);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchPosts();

    return () => {
      isMounted = false;
    };
  }, [countNewsHome]);

  return { data, isLoading, isError };
}
export function useGetAllPostsCard() {
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function fetchPosts() {
      setLoading(true);
      setError(false);

      try {
        const response = await NewsService.getAllPostsCard();
        if (isMounted) {
          setData(response);
        }
      } catch (error) {
        if (isMounted) {
          setError(true);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchPosts();

    return () => {
      isMounted = false;
    };
  }, []);

  return { data, isLoading, isError };
}
